module.exports = __webpack_public_path__ + "static/media/G_iTvcwvTVGFP81_Quybzg_thumb_1178.cf89a8fd.jpg";